



































import { Vue } from 'vue-property-decorator'
import ScreenTile from '../../components/ScreenTile.vue'
import ReportsTab from './ReportsTab.vue'
import MDDocumentsTab from './MDDocumentsTab.vue'
import AgentResourcesTab from './AgentResourcesTab.vue'
import ReinsuranceResourcesTab from './ReinsuranceResourcesTab.vue'
import { mapState } from 'vuex'

import '../../styles/favorites.css'

interface IDocument {
  key: string
  id: number
  name: string
  createdDate: string
  favoriteId: number
  resourceLink: string
  source: string
  isDirectory: boolean
  type: string
  path?: string
}

export default Vue.extend({
  data: function () {
    return {
      tab: 'folders',
    }
  },
  methods: {
    removeFavorite: async (favoriteId: number) => {
      await fetch(`/api/favorites/${favoriteId}`, { method: 'DELETE' })
    },
    openAgentDocument: async function (document: IDocument) {
      if (document.isDirectory) {
        this.$router.push(`/${document.type}/${document.id}`)
        return
      }
      try {
        const canOpenResource = await fetch(`${document.resourceLink}`)

        if (canOpenResource.ok) {
          window.open(document.resourceLink)
        }
      } catch {
        console.log('error')
      }
    },
    openMDDocument: async function (document: IDocument) {
      if (document.isDirectory) {
        this.$router.push(`/${document.type}/${document.id}`)
        return
      }
      try {
        const canOpenResource = await fetch(`${document.resourceLink}`)

        if (canOpenResource.ok) {
          window.open(document.resourceLink)
        }
      } catch {
        console.log('error')
      }
    },
    openReinsuranceResource: async function (document: IDocument) {
      if (!document.path) return
      const fileName =
        document.path.split('/')[document.path.split('/').length - 1]
      if (fileName.includes('.')) {
        // document
        window.open(`/api/reinsuranceresources/download?path=${document.path}`)
      } else {
        // folder
        this.$router.push(`/reinsurance-resources/${document.path}`)
      }
    },
  },
  computed: {
    ...mapState(['user']),
    tabs: function () {
      return this.user.canAccessMdResources
        ? [
            'reports',
            'md documents',
            'agent resources',
            'reinsurance resources',
          ]
        : ['reports', 'agent resources', 'reinsurance resources']
    },
  },
  components: {
    ScreenTile,
    ReportsTab,
    MDDocumentsTab,
    AgentResourcesTab,
    ReinsuranceResourcesTab,
  },
})
